/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { toast, ToastContent, ToastOptions } from "react-toastify";

const defaultOptions = {
  position: "top-right" as const,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export const showSimpleInfo = (
  text: string,
  autoClose: number | false = 2000
) =>
  toast.info(text, {
    ...defaultOptions,
    autoClose,
  });

export const showSuccess = (
  text: string,
  autoClose: number | false = 2000,
  onClick?: () => void
) =>
  toast.success(text, {
    ...defaultOptions,
    autoClose,
    onClick,
  });

export const showError = (content: ToastContent, options?: ToastOptions) =>
  toast.error(content, {
    ...defaultOptions,
    ...options,
  });
